import { createSlice } from '@reduxjs/toolkit';
import * as Sentry from "@sentry/gatsby"
import { getDealsFromCustomerId, getDealFromId, CustomerDeals, getCustomerDealsFromURL } from './actions';

const initialState = {
  loading: false,
  hasErrors: false,
  deal: null,
  customerDeals: null as CustomerDeals | null,
}

const dealSlice = createSlice({
  name: 'deals',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getDealFromId.pending, state => {
      state.loading = true;
    });
    builder.addCase(
      getDealFromId.fulfilled,
      (state, { payload }) => {
        state.hasErrors = false;
        state.loading = false;
        state.deal = payload;
      },
    );
    builder.addCase(
      getDealFromId.rejected,
      (state, { error }) => {
        Sentry.captureException(error);
        state.hasErrors = true;
        state.loading = false;
      },
    );
    builder.addCase(getDealsFromCustomerId.pending, state => {
      state.loading = true;
    });
    builder.addCase(
      getDealsFromCustomerId.fulfilled,
      (state, { payload }) => {
        state.hasErrors = false;
        state.loading = false;
        state.customerDeals = payload;
      },
    );
    builder.addCase(
      getDealsFromCustomerId.rejected,
      (state, { error }) => {
        Sentry.captureException(error);
        state.hasErrors = true;
        state.loading = false;
      },
    );
    builder.addCase(getCustomerDealsFromURL.pending, state => {
      state.loading = true;
    });
    builder.addCase(
      getCustomerDealsFromURL.fulfilled,
      (state, { payload }) => {
        state.hasErrors = false;
        state.loading = false;
        if (state.customerDeals) {
          // combine the list of deals
          const oldCustomerDeals = state.customerDeals;
          oldCustomerDeals.next = payload.next;
          oldCustomerDeals.results.concat(payload.results)
          state.customerDeals = oldCustomerDeals;
        } else {
          state.customerDeals = payload;
        }
        
      },
    );
    builder.addCase(
      getCustomerDealsFromURL.rejected,
      (state) => {
        state.hasErrors = true;
        state.loading = false;
      },
    );
  }
})

export default dealSlice.reducer;
